'use client';

import dynamic from 'next/dynamic';
import Toaster from '@/components/ui/toaster';

const DynamicEventListener = dynamic(() => import('@/components/EventListener'), {
  ssr: false,
});

const DynamicCookieConsent = dynamic(() => import('@/components/CookieConsent'), {
  ssr: false,
});
const DynamicCartExitIntent = dynamic(() => import('@/components/CartExitIntentModal'), {
  ssr: false,
});

const DynamicVisualViewportInsetSync = dynamic(
  () => import('@/components/VisualViewportInsetSync'),
  { ssr: false },
);

const DynamicWidgetFabRouteClass = dynamic(() => import('@/components/WidgetFabRouteClass'), {
  ssr: false,
});

export default function RootLayoutView({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <>
      <DynamicVisualViewportInsetSync />
      <DynamicWidgetFabRouteClass />
      <DynamicEventListener>{children}</DynamicEventListener>
      <Toaster />
      <DynamicCartExitIntent />
    </>
  );
}
